import { render, staticRenderFns } from "./CloseShiftModal.vue?vue&type=template&id=70db8762"
import script from "./CloseShiftModal.vue?vue&type=script&lang=js"
export * from "./CloseShiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports